export default __webpack_public_path__ + "static/media/img-0652-lithuania-full-face.ce210a5e.png";